import { provideEffects } from '@ngrx/effects';
import { ACCOUNT_FEATURE_KEY, AccountEffects, AccountFacade, accountReducer } from './+state';
import { provideState } from '@ngrx/store';

export * from './+state';


export const accountProviders = [

  // ngrx
  AccountFacade,
  provideState(ACCOUNT_FEATURE_KEY, accountReducer),
  provideEffects(AccountEffects),
];
